import { render, staticRenderFns } from "./setUpPage.vue?vue&type=template&id=6ee103a3&scoped=true"
import script from "./setUpPage.vue?vue&type=script&lang=js"
export * from "./setUpPage.vue?vue&type=script&lang=js"
import style0 from "./setUpPage.vue?vue&type=style&index=0&id=6ee103a3&prod&lang=scss&scoped=true"
import style1 from "./setUpPage.vue?vue&type=style&index=1&id=6ee103a3&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ee103a3",
  null
  
)

export default component.exports